import type { ReactNode } from "react"

import {
  useFormContext,
  type FieldPath,
  type FieldValues,
} from "react-hook-form"

import { Checkbox } from "@/components/ui/checkbox"
import {
  FormField,
  FormControl,
  FormItem,
  FormMessage,
} from "@/components/ui/form"
import { cn } from "@/lib/utils"

export type FormCheckboxProps<T extends FieldValues = FieldValues> = {
  name: FieldPath<T>
  label: string | ReactNode
  id?: string
  className?: string
  messageClassName?: string
  disabled?: boolean
}

export function FormCheckbox<T extends FieldValues = FieldValues>({
  name,
  label,
  id,
  className,
  messageClassName,
  disabled = false,
}: FormCheckboxProps<T>) {
  const form = useFormContext<T>()

  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col gap-2">
          <div className="flex flex-row items-start gap-2">
            <FormControl>
              <Checkbox
                id={id || name}
                checked={field.value}
                onCheckedChange={field.onChange}
                className={cn("border-muted/50", className)}
                disabled={disabled}
              />
            </FormControl>
            <label htmlFor={id || name} className="text-sm leading-none">
              {label}
            </label>
          </div>
          <FormMessage className={cn("form-error", messageClassName)} />
        </FormItem>
      )}
    />
  )
}
